<template>
  <div>
    <adjustment-tabs :type="type"></adjustment-tabs>
    <v-card class="white rounded-lg">
      <v-card-title class="secondary--text">{{ title }}</v-card-title>
      <v-card-text>
        <m-datatable
            :headers="headers"
            :apiUrl="url"
            :filters.sync="filters"
            ref="datatable"
            @dblclick:row="(e, row) => $router.push(to(row.item))"
            :exportUrl="exportUrl"
        >
          <template #item.remain="{ item }">{{
              getRemain(item) | toMoney
            }}
          </template>
          <template #item.settle="{ item }">
            <v-btn color="light-blue white--text" :to="toSettle(item)" text
            >تسویه
            </v-btn
            >
          </template>
          <template #item.detail="{ item }">
            <detail-link :to="to(item)"/>
          </template>
        </m-datatable>
      </v-card-text>
    </v-card>
  </div>

</template>

<script>
import AdjustmentTabs from "@/views/panel/adjustment/AdjustmentTabs";

export default {
  name: "AdjustmentsList",
  components: {AdjustmentTabs},
  props: {
    type: {},
  },
  data() {
    return {
      filters: {},
      exportUrl: "reports/lists/adjustments",
      url: "reports/lists/factors",
    };
  },
  computed: {
    title() {
      switch (this.type) {
        case "ia":
          return this.setDocumentTitle("لیست رسید های تعدیل انبار");
        case "oa":
          return this.setDocumentTitle("لیست حواله های تعدیل انبار");
      }
    },
    headers() {
      let headers = [
        {
          text: "شماره",
          value: "code",
        },
        {
          text: "تاریخ",
          value: "date",
        },
        {
          text: "از انبارگردانی",
          value: "is_from_warehouse_handling",
          type: 'boolean'
        },
        {
          text: "توضیحات",
          value: "explanation",
        },
      ];

      headers.push({
        text: "جزئیات",
        value: "detail",
        sortable: false,
        filterable: false,
      });

      return headers;
    },
  },
  created() {
    this.filters.type = this.type;
  },
  watch: {
    $route() {
      this.$refs.datatable.getDataFromApi();
      this.filters.type = this.type;
    },
  },
  methods: {
    to(item) {
      return {
        name: "AdjustmentForm",
        params: {
          type: this.type,
          id: item.id,
        },
      };
    },
  },
};
</script>

<style scoped lang="scss"></style>
